import { render, staticRenderFns } from "./gameplay-players-top-award-hit.vue?vue&type=template&id=05c160fb&scoped=true&"
import script from "./gameplay-players-top-award-hit.vue?vue&type=script&lang=js&"
export * from "./gameplay-players-top-award-hit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c160fb",
  null
  
)

export default component.exports